module.exports = __webpack_public_path__ + "img/19.777747a.jpg";